import { LOCAL_WSPI_URL } from "@/api/base";

// 第一步：验证配置加载
console.log("🔧 websocket.js加载 - 验证配置:");
console.log("导入的 LOCAL_WSPI_URL:", LOCAL_WSPI_URL);

if (!LOCAL_WSPI_URL) {
  console.error("🚨 严重: LOCAL_WSPI_URL未定义!");
} else if (LOCAL_WSPI_URL.includes('undefined')) {
  console.error("🚨 严重: LOCAL_WSPI_URL包含'undefined'!");
}

const CHAT_WS_URL = `${LOCAL_WSPI_URL}/public/stream-chat-endpoint`;
console.log("🌐 最终 CHAT_WS_URL:", CHAT_WS_URL);

// 存储所有活跃的 WebSocket 连接和回复内容
const activeConnections = new Map();  // key: threadSlug, value: { socket, replyContent, reconnectAttempts }

// 初始化WebSocket连接
export function initWebSocket(threadSlug, aiSeatId, workspaceSlug) {
  console.log("=== initWebSocket 开始 ===");
  console.log("📌 输入参数:", { 
    threadSlug, 
    aiSeatId, 
    workspaceSlug,
    "aiSeatId类型": typeof aiSeatId,
    "aiSeatId值": aiSeatId,
    "workspaceSlug类型": typeof workspaceSlug,
    "workspaceSlug值": workspaceSlug
  });
  
  // 严格的参数验证
  if (!threadSlug || threadSlug === 'undefined' || threadSlug === 'null') {
    console.error("🚨 错误: threadSlug参数无效!", threadSlug);
    return null;
  }
  if (!aiSeatId || aiSeatId === 'undefined' || aiSeatId === 'null') {
    console.error("🚨 错误: aiSeatId参数无效!", aiSeatId);
    return null;
  }
  if (!workspaceSlug || workspaceSlug === 'undefined' || workspaceSlug === 'null') {
    console.error("🚨 错误: workspaceSlug参数无效!", workspaceSlug);
    return null;
  }
  
  // 关闭旧连接（如果存在）
  if (activeConnections.has(threadSlug)) {
    const conn = activeConnections.get(threadSlug);
    if (conn.socket) {
      console.log(`🔄 [${threadSlug}] 关闭旧连接`);
      conn.socket.close();
    }
    if (conn.reconnectTimer) {
      clearTimeout(conn.reconnectTimer);
    }
    if (conn.heartbeatInterval) {
      clearInterval(conn.heartbeatInterval);
    }
  }
  
  // 确保URL正确
  if (!LOCAL_WSPI_URL || LOCAL_WSPI_URL.includes('undefined')) {
    console.error("🚨 无法创建WebSocket: LOCAL_WSPI_URL未正确配置");
    return null;
  }  

  
// 在URL中携带认证信息
const authParams = new URLSearchParams({
  threadSlug: String(threadSlug),
  aiSeatId: String(aiSeatId),
  workspaceSlug: String(workspaceSlug),    
  timestamp: Date.now()
});

console.log("📌 URL参数:", authParams.toString());

// 添加详细的URL调试信息
console.log("=== URL构建调试 ===");
console.log("1. LOCAL_WSPI_URL 原始值:", LOCAL_WSPI_URL);
console.log("2. CHAT_WS_URL 计算值:", CHAT_WS_URL);
console.log("3. 参数:", authParams.toString());

// 确保URL格式正确
let baseUrl;
if (LOCAL_WSPI_URL.startsWith('ws://') || LOCAL_WSPI_URL.startsWith('wss://')) {
  baseUrl = LOCAL_WSPI_URL;
} else {
  // 如果没有协议前缀，添加默认的 ws://
  baseUrl = `ws://${LOCAL_WSPI_URL}`;
}

const wsUrl = `${baseUrl}/public/stream-chat-endpoint?${authParams.toString()}`;

console.log("4. 最终 WebSocket URL:", wsUrl);
console.log("=== 调试结束 ===");

  console.log("🌐 完整WebSocket URL:", wsUrl);
  
  // 创建WebSocket连接
  let socket;
  try {
    socket = new WebSocket(wsUrl);
    console.log(`✅ [${threadSlug}] WebSocket实例创建成功`);
  } catch (error) {
    console.error(`❌ [${threadSlug}] 创建WebSocket失败:`, error);
    return null;
  }

  // 存储完整连接状态
  activeConnections.set(threadSlug, {
    socket,
    isConnected: false,
    reconnectAttempts: 0,
    reconnectTimer: null,
    lastActivity: null,
    replyContent: "",
    callbacks: new Set(),
    hasProcessedConversationTimeout: false,
    heartbeatInterval: null
  });

  const conn = activeConnections.get(threadSlug);
  
  // 添加详细的事件监听器
  socket.onopen = (event) => {
    console.log(`✅ [${threadSlug}] WebSocket连接成功打开`);
    console.log(`📊 状态:`, socket.readyState, "URL:", socket.url);
    handleSocketOpen(event, threadSlug);
  };
  
  socket.onerror = (error) => {
    console.error(`❌ [${threadSlug}] WebSocket连接错误`);
    console.error("错误详情:", error);
    console.error("目标URL:", socket.url);
    console.error("就绪状态:", socket.readyState);
    handleSocketError(error, threadSlug);
  };
  
  socket.onclose = (event) => {
    console.log(`🔒 [${threadSlug}] WebSocket连接关闭`);
    console.log("关闭代码:", event.code);
    console.log("关闭原因:", event.reason);
    console.log("是否干净关闭:", event.wasClean);
    handleSocketClose(event, threadSlug);
  };
  
  socket.onmessage = (event) => {
    console.log(`📥 [${threadSlug}] 收到消息:`, event.data ? event.data.substring(0, 100) : "空消息");
    handleSocketMessage(event, threadSlug);
  };

  return conn.socket;
}

// 注册回调函数时，回调函数应该有三个参数：
// function callback(content, isCompleted, error)
export function registerCallback(threadSlug, callback) {
  if (activeConnections.has(threadSlug)) {
    activeConnections.get(threadSlug).callbacks.add(callback);
    console.log(`✅ [${threadSlug}] 回调函数注册成功，当前回调数量:`, activeConnections.get(threadSlug).callbacks.size);
  } else {
    console.warn(`⚠️ [${threadSlug}] 无法注册回调: 连接不存在`);
  }
}

// 取消注册回调 - 新增函数
export function unregisterCallback(threadSlug, callback) {
  if (activeConnections.has(threadSlug)) {
    activeConnections.get(threadSlug).callbacks.delete(callback);
    console.log(`✅ [${threadSlug}] 回调函数取消注册`);
  }
}

export function getActiveConnection(threadSlug) {
  return activeConnections.get(threadSlug);
}

// 连接成功回调
function handleSocketOpen(event, threadSlug) {
  const conn = activeConnections.get(threadSlug);

  if (!conn) {
    console.error(`❌ [${threadSlug}] 连接成功但未找到连接记录`);
    return;
  }

  conn.isConnected = true;
  conn.lastActivity = Date.now();
  conn.reconnectAttempts = 0; // 重置重连计数器
  conn.hasProcessedConversationTimeout = false; // 重置CONVERSATION_TIMEOUT标记
  console.log(`✅ [${threadSlug}] 连接成功，开始心跳检测`);
  startHeartbeat(threadSlug);
}

// 接收消息处理
function handleSocketMessage(event, threadSlug) {
  if (!activeConnections.has(threadSlug)) {
    console.warn(`⚠️ [${threadSlug}] 收到消息但连接记录不存在`);
    return;
  }

  const connectionData = activeConnections.get(threadSlug);
  console.log(`📥 [${threadSlug}] 原始消息长度:`, event.data ? event.data.length : 0);

  try {
    // 1. 先检查是否是心跳包（字符串格式）
    if (event.data === '{"type":"heartbeat"}') {
      console.log(`💓 [${threadSlug}] 收到心跳包，跳过处理`);
      connectionData.lastActivity = Date.now();
      return;
    }
    
    // 2. 尝试解析JSON
    const response = JSON.parse(event.data);
    console.log(`📦 [${threadSlug}] 解析后的响应类型:`, response.type || '无类型字段');
    
    // 3. 再次检查心跳包（JSON格式）
    if (response.type === "heartbeat") {
      console.log(`💓 [${threadSlug}] 收到JSON心跳包，跳过处理`);
      connectionData.lastActivity = Date.now();
      return;
    }

    // 4. 检查是否是CONVERSATION_TIMEOUT消息
    if (response.type === "conversation_timeout" || response.status === "CONVERSATION_TIMEOUT") {
      console.log(`⏰ [${threadSlug}] 检测到对话结束消息（超时未响应）`);
      
      // 检查是否已经处理过CONVERSATION_TIMEOUT消息
      if (connectionData.hasProcessedConversationTimeout) {
        console.log(`⏰ [${threadSlug}] 已处理过CONVERSATION_TIMEOUT消息，跳过重复处理`);
        return;
      }
      
      // 标记已处理
      connectionData.hasProcessedConversationTimeout = true;
      
      // 触发回调，传递特殊标记和完整的reply内容
      connectionData.callbacks.forEach(callback => {
        if (typeof callback === 'function') {
          try {
            callback(event.data, 'conversation_timeout', null);
          } catch (e) {
            console.error(`❌ [${threadSlug}] 回调执行失败:`, e);
          }
        }
      });
      
      return;
    }

    // 5. 首先检查是否是错误消息
    if (response.error) {
      console.error(`❌ [${threadSlug}] 服务器返回错误:`, response.error);

      // 触发错误回调
      connectionData.callbacks.forEach(callback => {
        if (typeof callback === 'function') {
          callback('', false, response.error);
        }
      });

      // 如果是限流错误，可以自动关闭连接
      if (response.error.includes('超过限制')) {
        closeWebSocket(threadSlug);
      }
      return;
    }

    // 6. 处理chunk类型（流式片段）
    if (response.type === "chunk" && response.content) {
      console.log(`📝 [${threadSlug}] 收到chunk，长度:`, response.content.length);
      
      connectionData.replyContent += response.content;
      
      // 触发内容更新回调
      connectionData.callbacks.forEach(callback => {
        try {
          if (typeof callback === 'function') {
            callback(connectionData.replyContent, false, null);
          }
        } catch (e) {
          console.error(`❌ [${threadSlug}] 回调执行失败:`, e);
        }
      });

      // 更新最后活动时间
      connectionData.lastActivity = Date.now();
      return;
    }

    // 7. 处理processed类型（处理后的HTML）
    if (response.type === "processed" && response.content) {
      console.log(`🔄 [${threadSlug}] 收到处理后的HTML内容，长度:`, response.content.length);
      
      // 替换累积内容为处理后的HTML
      connectionData.replyContent = response.content;
      
      // 触发处理后的回调
      connectionData.callbacks.forEach(callback => {
        try {
          if (typeof callback === 'function') {
            callback(response.content, false, null);
          }
        } catch (e) {
          console.error(`❌ [${threadSlug}] 回调执行失败:`, e);
        }
      });
      
      // 更新最后活动时间
      connectionData.lastActivity = Date.now();
      return;
    }

    // 8. 处理end类型（流结束）
    if (response.type === "end") {
      console.log(`🏁 [${threadSlug}] 流式对话结束`);
      
      // 如果有content字段，使用它（可能是处理后的内容）
      if (response.content) {
        connectionData.replyContent = response.content;
      }
      
      // 触发完成回调
      connectionData.callbacks.forEach(callback => {
        if (typeof callback === 'function') {
          callback(connectionData.replyContent, true, null);
        }
      });
      
      // 清空累积内容
      connectionData.replyContent = "";
      return;
    }

    // 9. 检查是否是最终结束消息（兼容旧格式）
    if (response.status === "completed") {
      console.log(`✅ [${threadSlug}] 对话已完成`);
      // 触发完成回调
      connectionData.callbacks.forEach(callback => {
        if (typeof callback === 'function') {
          callback(connectionData.replyContent, true, null);
        }
      });
      return;
    }

    // 10. 处理正常内容消息（兼容旧格式）
    if (response.content) {
      connectionData.replyContent += response.content;
      
      // 触发内容更新回调
      connectionData.callbacks.forEach(callback => {
        try {
          if (typeof callback === 'function') {
            callback(connectionData.replyContent, false, null);
          }
        } catch (e) {
          console.error(`❌ [${threadSlug}] 回调执行失败:`, e);
        }
      });

      // 更新最后活动时间
      connectionData.lastActivity = Date.now();
    }

  } catch (e) {
    console.error(`❌ [${threadSlug}] 消息解析失败:`, e, "原始数据:", event.data);
  }
}

// 错误处理
function handleSocketError(error, threadSlug) {
  console.error(`❌ [${threadSlug}] WebSocket错误:`, error);

  const conn = activeConnections.get(threadSlug);
  if (conn) {
    // 触发所有回调通知错误
    conn.callbacks.forEach(callback => {
      if (typeof callback === 'function') {
        try {
          callback('', false, `连接错误: ${error.message || '未知错误'}`);
        } catch (e) {
          console.error('回调执行失败:', e);
        }
      }
    });
  }
  
  // 尝试重连（如果参数有效）
  if (threadSlug) {
    attemptReconnect(threadSlug);
  }
}

function handleSocketClose(event, threadSlug) {
  const conn = activeConnections.get(threadSlug);
  if (!conn) {
    console.warn(`⚠️ [${threadSlug}] 连接关闭但未找到连接记录`);
    return;
  }

  conn.isConnected = false;
  console.log(`🔒 [${threadSlug}] 连接关闭，状态码: ${event.code}, 原因: ${event.reason}`);

  // 通知所有回调连接关闭
  conn.callbacks.forEach(callback => {
    if (typeof callback === 'function') {
      try {
        callback('', false, '连接已关闭');
      } catch (e) {
        console.error('回调执行失败:', e);
      }
    }
  });

  // 如果不是正常关闭，尝试重连
  if (event.code !== 1000 && !event.wasClean) {
    console.log(`🔄 [${threadSlug}] 非正常关闭，准备重连...`);
    handleReconnect(threadSlug);
  }
}

const MAX_RECONNECT_ATTEMPTS = 3; // 最大重连次数
let RECONNECT_DELAY = 30000; // 重连延迟

// 为每个会话独立重连
export function attemptReconnect(threadSlug, aiSeatId, workspaceSlug) {
  const conn = activeConnections.get(threadSlug);
  if (!conn) {
    console.warn(`⚠️ [${threadSlug}] 尝试重连但连接记录不存在`);
    return;
  }

  // 清除现有定时器
  if (conn.reconnectTimer) {
    clearTimeout(conn.reconnectTimer);
    conn.reconnectTimer = null;
  }

  // 检查是否达到最大重试次数
  if (conn.reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
    console.error(`❌ [${threadSlug}] 停止重连：已达最大尝试次数 (${MAX_RECONNECT_ATTEMPTS})`);
    
    // 通知回调连接失败
    conn.callbacks.forEach(callback => {
      if (typeof callback === 'function') {
        try {
          callback('', false, '连接失败：已达到最大重连次数');
        } catch (e) {
          console.error('回调执行失败:', e);
        }
      }
    });
    
    return;
  }

  console.log(`🔄 [${threadSlug}] 第 ${conn.reconnectAttempts + 1} 次重连，延迟: ${RECONNECT_DELAY}ms`);

  // 安排下一次重试
  conn.reconnectTimer = setTimeout(() => {
    conn.reconnectAttempts++;
    
    // 如果提供了重连参数，使用它们重新初始化
    if (aiSeatId && workspaceSlug) {
      console.log(`🔄 [${threadSlug}] 使用新参数重连`);
      initWebSocket(threadSlug, aiSeatId, workspaceSlug);
    } else {
      console.warn(`⚠️ [${threadSlug}] 重连参数不全，无法重连`);
    }
  }, RECONNECT_DELAY);
}

// 关闭特定会话的WebSocket
export function closeWebSocket(threadSlug) {
  if (activeConnections.has(threadSlug)) {
    const conn = activeConnections.get(threadSlug);
    console.log(`🛑 [${threadSlug}] 关闭WebSocket连接`);

    // 清除所有定时器
    if (conn.reconnectTimer) {
      clearTimeout(conn.reconnectTimer);
      conn.reconnectTimer = null;
    }
    if (conn.heartbeatInterval) {
      clearInterval(conn.heartbeatInterval);
      conn.heartbeatInterval = null;
    }

    // 清空回调集合
    conn.callbacks.clear();

    // 关闭socket如果打开
    if (conn.socket && conn.socket.readyState !== WebSocket.CLOSED) {
      conn.socket.close(1000, '正常关闭');
    }

    // 从map中移除
    activeConnections.delete(threadSlug);
    console.log(`✅ [${threadSlug}] WebSocket已完全关闭并清理`);
  } else {
    console.log(`ℹ️ [${threadSlug}] 关闭WebSocket: 连接不存在`);
  }
}

// 心跳检测
function startHeartbeat(threadSlug) {
  const conn = activeConnections.get(threadSlug);
  if (!conn) return;

  // 清除可能存在的旧定时器
  if (conn.heartbeatInterval) {
    clearInterval(conn.heartbeatInterval);
  }

  conn.heartbeatInterval = setInterval(() => {
    if (conn.socket && conn.socket.readyState === WebSocket.OPEN) {
      // 发送心跳包
      conn.socket.send(JSON.stringify({ 
        type: "heartbeat", 
        timestamp: Date.now()
      }));
      console.log(`💓 [${threadSlug}] 发送心跳包`);
    } else {
      console.log(`💔 [${threadSlug}] 心跳检测停止: WebSocket未打开`);
      clearInterval(conn.heartbeatInterval);
      conn.heartbeatInterval = null;
    }
  }, 30000);
}

// 统一状态检查方法
export function isReallyConnected(threadSlug) {
  const conn = activeConnections.get(threadSlug);
  if (!conn) return false;

  // 检查是否有socket并且处于OPEN状态
  const isSocketReady = conn.socket && conn.socket.readyState === WebSocket.OPEN;

  // 检查最近是否有活动（1.5分钟）
  const isRecentActivity = conn.lastActivity &&
                          (Date.now() - conn.lastActivity < 90000);

  return conn.isConnected && isSocketReady && isRecentActivity;
}

const MAX_RETRY = 3; // 最大重试次数
function handleReconnect(threadSlug, aiSeatId, workspaceSlug) {
  const conn = activeConnections.get(threadSlug);
  if (!conn || conn.reconnectAttempts >= MAX_RETRY) {
    console.log(`❌ [${threadSlug}] 停止重连: 连接不存在或已达最大重试次数`);
    return;
  }

  console.log(`🔄 [${threadSlug}] 计划重连，延迟: ${RECONNECT_DELAY}ms`);
  
  conn.reconnectTimer = setTimeout(() => {
    // 如果提供了参数，使用它们重新初始化
    if (aiSeatId && workspaceSlug) {
      console.log(`🔄 [${threadSlug}] 执行重连，使用参数:`, { aiSeatId, workspaceSlug });
      initWebSocket(threadSlug, aiSeatId, workspaceSlug);
    } else {
      console.warn(`⚠️ [${threadSlug}] 重连参数不全，无法重连`);
    }
    conn.reconnectAttempts++;
  }, RECONNECT_DELAY);
}

// 添加连接状态检查方法
export function waitForConnection(threadSlug, timeout = 5000, aiSeatId, workspaceSlug) {
  return new Promise((resolve, reject) => {
    if (!threadSlug) {
      return reject(new Error('threadSlug不能为空'));
    }

    const startTime = Date.now();
    console.log(`⏳ [${threadSlug}] 等待连接建立，超时: ${timeout}ms`);

    const conn = activeConnections.get(threadSlug);

    // 如果连接不存在或处于关闭状态，重新初始化（需要参数）
    if (!conn || (conn.socket && conn.socket.readyState === WebSocket.CLOSED)) {
      console.log(`🔄 [${threadSlug}] 初始化新连接...`);
      
      if (!aiSeatId || !workspaceSlug) {
        return reject(new Error('重新初始化需要aiSeatId和workspaceSlug参数'));
      }
      
      initWebSocket(threadSlug, aiSeatId, workspaceSlug);
    }

    const checkInterval = setInterval(() => {
      const currentConn = activeConnections.get(threadSlug);
      
      if (currentConn && currentConn.socket && currentConn.socket.readyState === WebSocket.OPEN) {
        clearInterval(checkInterval);
        console.log(`✅ [${threadSlug}] 连接建立成功`);
        resolve(true);
      }

      // 超时处理
      if (Date.now() - startTime > timeout) {
        clearInterval(checkInterval);
        console.error(`⏰ [${threadSlug}] 连接等待超时`);
        reject(new Error(`连接超时`));
      }
    }, 100);
  });
}

// 添加连接状态监控方法
export function getConnectionState(threadSlug) {
  const conn = activeConnections.get(threadSlug);
  
  if (!conn || !conn.socket) {
    console.log(`ℹ️ [${threadSlug}] 连接状态: 不存在`);
    return '不存在';
  }

  let state;
  switch(conn.socket.readyState) {
    case WebSocket.CONNECTING: state = '连接中'; break;
    case WebSocket.OPEN: state = '已连接'; break;
    case WebSocket.CLOSING: state = '关闭中'; break;
    case WebSocket.CLOSED: state = '已关闭'; break;
    default: state = '未知';
  }
  
  console.log(`ℹ️ [${threadSlug}] 连接状态: ${state}`);
  return state;
}

// 导出一些调试信息
export function debugConnections() {
  console.log("🔍 当前活跃连接:", activeConnections.size);
  activeConnections.forEach((conn, key) => {
    console.log(`  - ${key}:`, {
      readyState: conn.socket ? conn.socket.readyState : '无socket',
      isConnected: conn.isConnected,
      callbacks: conn.callbacks.size,
      reconnectAttempts: conn.reconnectAttempts
    });
  });
}